import { Component } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Observable, take } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';

@Component({
  selector: 'app-quick-order-clear-modal',
  templateUrl: './quick-order-clear-modal.component.html',
  styleUrls: ['./quick-order-clear-modal.component.scss'],
  standalone: false,
})
export class QuickOrderClearModalComponent {
  entries: any[];

  constructor(
    protected modalService: StandardModalService,
    private messageService: GlobalMessageService,
    private languageService: ShimanoLanguageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.entries = res.entries;
      });
  }

  clearEntries(): void {
    this.entries = [];
    this.closeModal(this.entries);
    this.messageService.add(
      { key: 'cart.quickOrder.clearModal.resetSuccess' },
      GlobalMessageType.MSG_TYPE_CONFIRMATION
    );
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  customizeStylingButtons(activeLanguage: any): boolean {
    return ['de', 'es', 'pl', 'no', 'pt', 'fr_CA'].includes(activeLanguage);
  }
}
